import { Codename, WorkstationDocument } from '@/api/types/workstation'
import { RequestInfo } from '@/store/types/root'

export type WorkstationUsageTime = {
  totalHours: number
  hoursRemaining: number
  cycleResetTimestamp: number
}

export type WorkstationRequests = {
  startWorkstation: RequestInfo
  stopWorkstation: RequestInfo
  deleteWorkstation: RequestInfo
  createWorkstation: RequestInfo
  connectToWorkstationRDP: RequestInfo
  connectToWorkstationTGX: RequestInfo
  connectToWorkstationTeradici: RequestInfo
  changeWorkstationName: RequestInfo
  modifyRootVolume: RequestInfo
}

export type WorkstationRequestName =
  | 'startWorkstation'
  | 'stopWorkstation'
  | 'deleteWorkstation'
  | 'createWorkstation'
  | 'connectToWorkstationRDP'
  | 'connectToWorkstationTGX'
  | 'connectToWorkstationTeradici'
  | 'changeWorkstationName'
  | 'modifyRootVolume'

export type RequestStatus = 'none' | 'pending' | 'successful' | 'failed'

export class WorkstationRequestUpdate {
  name: WorkstationRequestName
  info: RequestInfo
  uuid: string
  constructor(uuid: string, name: WorkstationRequestName, status: RequestStatus, error?: string) {
    this.uuid = uuid
    this.name = name
    this.info = new RequestInfo({ status, error })
  }
}

export type WorkstationsRequests = {
  [key: string]: WorkstationRequests
}

export type WorkstationState = {
  ownerWorkstations: Array<WorkstationDocument> | null
  shareeWorkstations: Array<WorkstationDocument> | null
  workstationsRequests: WorkstationsRequests
  usage: WorkstationUsageTime | null
}

export type WorkstationData = {
  name?: string
  codename?: Codename
}

export type Range = {
  cpu: number
  ram: number
  gpu: number
}

export type WorkstationsRanges = {
  [key: string]: Range
}
